module.exports = __webpack_public_path__ + "media/dead.38380a37.mp3";